<template>
  <b-modal :visible="isOpen"
           lazy
           centered
           ok-variant="ls"
           :ok-title="$t('Close')"
           ok-only
           :title="rewardOrder.name"
           @hidden="clearModal"
           @shown="fetchMaterialOrder"
           size="lg">
    <div v-if="rewardOrder.name">
      <div class="row px-lg-5">
        <div class="col-12 col-lg-7 d-flex flex-column justify-content-center">
          <div class="row mb-3 mb-sm-0">
            <div class="col-12 col-sm-5 text-center text-sm-right"><strong>{{$t('Order status')}}</strong></div>
            <div class="col-12 col-sm-7 col-lg-6 text-center text-sm-left">{{ status }}</div>
          </div>
          <div class="row mb-3 mb-sm-0">
            <div class="col-12 col-sm-5 text-center text-sm-right"><strong>{{$t('Quantity')}}</strong></div>
            <div class="col-12 col-sm-7 col-lg-6 text-center text-sm-left">{{ rewardOrder.quantity }}</div>
          </div>
          <div class="row mb-3 mb-sm-0" v-if="rewardOrder.credits>0">
            <div class="col-12 col-sm-5 text-center text-sm-right"><strong>{{ $t('Cost') }}</strong></div>
            <div class="col-12 col-sm-7 col-lg-6 text-center text-sm-left">{{ rewardOrder.credits }} {{pointsSymbol}}</div>
          </div>
          <div class="row mb-3 mb-sm-0">
            <div class="col-12 col-sm-5 text-center text-sm-right"><strong>{{$t('Collection method')}}</strong></div>
            <div class="col-12 col-sm-7 col-lg-6 text-center text-sm-left" v-if="rewardOrder.type === '1' && details">
              <p class="mb-0">{{$t('Shipping address')}}</p>
              <p class="mb-0">{{ details.name }} {{ details.surname }}</p>
              <p class="mb-0">{{ details.address }}</p>
              <p class="mb-0">{{ details.postcode }} {{ details.city }}</p>
              <p v-if="details.phone" class="mb-0">tel. {{ details.phone }}</p>
            </div>
            <div class="col-12 col-sm-7 col-lg-6 text-center text-sm-left" v-if="rewardOrder.type === '0' || rewardOrder.type === '3'">
              {{$t('Pickup in')}} {{ rewardOrder.shop_name }}
            </div>
          </div>
          <div v-if="details && details.details" class="row">
            <div class="col-12 col-sm-5 text-center text-sm-right"><strong>{{$t('Comments')}}</strong></div>
            <div class="col-12 col-sm-7 col-lg-6 text-center text-sm-left">{{ details.details }}</div>
          </div>
        </div>
        <div class="col-12 col-lg-4 d-flex flex-column align-items-center justify-content-center mt-5 mt-lg-0">
          <div>{{$t('Order ID')}}</div>
          <div>
            <vue-barcode :value="rewardOrder.order_number" format="code128">
              <h1>
                {{ rewardOrder.order_number }}
              </h1>
            </vue-barcode>
          </div>
        </div>
      </div>
    </div>
    <div v-else>{{$t('Error occurred, try again')}}</div>
  </b-modal>
</template>

<script>
import {mapActions, mapGetters, mapState} from 'vuex';
import VueBarcode from 'vue-barcode'

export default {
  name: "MaterialRewardModal",
  components: {
    VueBarcode
  },
  data() {
    return {
      rewardOrder: {
        reward_name: '',
        details: '{}'
      }
    }
  },
  methods: {
    ...mapActions([
      'clearMaterialOrderModalId'
    ]),
    clearModal() {
      this.clearMaterialOrderModalId();
      this.$set(this, 'rewardOrder', {
        reward_name: '',
        details: '{}'
      });
    },
    fetchMaterialOrder() {
      const rewardOrder = this.getRewardOrderById(this.stateOrder);

      if (rewardOrder) {
        this.rewardOrder = rewardOrder;
      }
    }
  },
  computed: {
    ...mapState({
      isOpen: state => state.rewards.materialOrderModalId !== null,
      stateOrder: state => state.rewards.materialOrderModalId,
      pointsConfig: state => state.settings.points,
      pointsSymbol() {
        return this.pointsConfig.symbol ? this.pointsConfig.symbol : 'pkt.';
      },
      pointsName() {
        return this.pointsConfig.name ? this.pointsConfig.name.charAt(0).toUpperCase() + this.pointsConfig.name.slice(1) : this.$t('Points');
      }
    }),
    ...mapGetters([
      'getRewardOrderById'
    ]),
    details() {
      return JSON.parse(this.rewardOrder.details || null);
    },
    status() {
      switch (this.rewardOrder.status) {
        case '0':
          return this.$t('Waiting');
        case '1':
          return this.$t('Sent');
        case '2':
          return this.$t('Delivered');
        case '3':
          return this.$t('Cancelled');
      }

      return '';
    }
  }
}
</script>

<style>
.modal-body {
  word-wrap: break-word;
}
</style>
